import { inject, injectable } from '@servicetitan/react-ioc';
import { CustomerPortalEnvApi, EnvSettings } from 'api';
import { makeObservable, observable, runInAction } from 'mobx';

@injectable()
export class EnvStore {
    @observable settings?: EnvSettings;

    constructor(@inject(CustomerPortalEnvApi) private envApi: CustomerPortalEnvApi) {
        makeObservable(this);
    }

    async loadData() {
        const response = await this.envApi.getEnvSettings();
        runInAction(() => {
            this.settings = response.data;
        });
    }
}
